export default function About() {
  return (
    <section id="about" className="relative bg-[#1a1a1a] py-40 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="aboutPattern" width="60" height="60" patternUnits="userSpaceOnUse">
              <circle cx="30" cy="30" r="2" fill="white" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#aboutPattern)" />
        </svg>
      </div>

      <div className="absolute inset-0 flex items-center justify-center opacity-5">
        <div className="w-[600px] h-[600px] rounded-full bg-gradient-to-br from-[#0066ff] to-[#ff6b6b] blur-3xl"></div>
      </div>

      <div className="relative max-w-[800px] mx-auto px-20 text-center">
        <div className="mb-8">
          <span className="text-xs font-bold text-[#0066ff] tracking-[4px] uppercase">
            ABOUT SAID LTDA
          </span>
        </div>

        <h2 className="text-5xl font-bold text-white mb-10 leading-tight">
          Committed to Your Digital Privacy
        </h2>

        <div className="space-y-6 max-w-[680px] mx-auto">
          <p className="text-lg text-[#b8b8b8] leading-relaxed">
            SAID LTDA was founded with a singular mission: to protect your digital freedom and privacy in an increasingly connected world. We believe that everyone deserves the right to browse the internet securely and anonymously, without fear of surveillance or data breaches.
          </p>

          <p className="text-lg text-[#b8b8b8] leading-relaxed">
            Our VPN service is built on cutting-edge technology and a commitment to transparency. We employ military-grade encryption protocols to ensure that your data remains completely secure, while our strict no-logs policy guarantees that your online activities are never tracked or stored.
          </p>

          <p className="text-lg text-[#b8b8b8] leading-relaxed">
            Based in Colombia, we serve users worldwide with a global network of high-speed servers. Our team of cybersecurity experts works tirelessly to stay ahead of emerging threats, continuously updating our infrastructure to provide you with the most reliable and secure VPN experience possible.
          </p>

          <p className="text-lg text-[#b8b8b8] leading-relaxed">
            At SAID LTDA, we're not just providing a service – we're championing a fundamental right. Your privacy matters, and we're here to protect it every step of the way.
          </p>
        </div>
      </div>
    </section>
  );
}
